export const GET_SUGGEST_ORDERS = {
    REQUEST: 'ORDER.GET_SUGGEST_ORDERS.REQUEST',
    SUCCESS: 'ORDER.GET_SUGGEST_ORDERS.SUCCESS',
    FAILED: 'ORDER.GET_SUGGEST_ORDERS.FAILED',
    SET_SUGGEST_ORDER_ID: 'SET_SUGGEST_ORDER_ID'
};